export const State2 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" fill="white" fillOpacity="0.01" />
    <rect
      x="1"
      y="6"
      width="7.07123"
      height="7.07123"
      rx="0.883904"
      transform="rotate(-45 1 6)"
      fill="#AB6400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.47565 3.83617C5.46483 3.5716 5.68986 3.35156 5.97125 3.35156C6.25264 3.35156 6.47766 3.5716 6.46685 3.83618L6.35354 6.60805C6.34564 6.80133 6.17683 6.9542 5.97125 6.9542C5.76568 6.9542 5.59685 6.80133 5.58895 6.60805L5.47565 3.83617ZM6.52339 7.98605C6.52339 8.27301 6.27615 8.50565 5.97117 8.50565C5.66618 8.50565 5.41895 8.27301 5.41895 7.98605C5.41895 7.69908 5.66618 7.46643 5.97117 7.46643C6.27615 7.46643 6.52339 7.69908 6.52339 7.98605Z"
      fill="#FFF7C2"
    />
  </svg>
);
